import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs';
import { Utils } from '@app/_core/helper/Utils';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInfoService {
  MemberData: any;
  MemberSearchData: any;
  ProviderData: any;
  ProviderSearchData: any;
  ClaimData: any;
  ClaimSearchData: any;
  MemberInfoData: any;
  ProviderTabularData: any;
  ProviderInfoData: any;
  ClaimTabularData: any;
  ClaimInfoData: any;

  constructor(private http: HttpClient,
      private loaderService: LoaderService,
  ) { }
  setMemberInfoData(value)
  {
    this.MemberInfoData=value;
  }
  getMemberInfoData()
  {
    return this.MemberInfoData;
  }
  getMemberTabularData()
  {
    return this.MemberData;
  }

  setMemberTabularData(value)
  {
    this.MemberData=value;
  }
  getMemberSearchData()
  {
    return this.MemberSearchData;
  }
  setMemberSearchData(value)
  {
    this.MemberSearchData=value;
  }
  getFormattedDate(date:Date){
    
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() returns 0-11, so we add 1
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${month}/${day}/${year}`;
    
  }
  getAdditionalInfo(payload:any)
  {
    return this.http.post(`${environment.apiUrl}api/service/Data/CallCustomMethod`, payload).pipe(
          map(res => {
            this.loaderService.display(false);
            //console.log(res);
            return res;
          }),
          catchError(Utils.handleHttpError)
        );
  }

  getProviderTabularData()
  {
    return this.ProviderTabularData;
  }

  setProviderTabularData(value)
  {
    this.ProviderTabularData=value;
  }

  getProviderInfoData()
  {
    return this.ProviderInfoData;
  }

  setProviderInfoData(value)
  {
    this.ProviderInfoData=value;
  }
  getProviderSearchData()
  {
    return this.ProviderSearchData;
  }
  setProviderSearchData(value)
  {
    this.ProviderSearchData=value;
  }
  getClaimTabularData()
  {
    return this.ClaimTabularData;
  }

  setClaimTabularData(value)
  {
    this.ClaimTabularData=value;
  }
  getClaimInfoData()
  {
    return this.ClaimInfoData;
  }

  setClaimInfoData(value)
  {
    this.ClaimInfoData=value;
  }
  getClaimSearchData()
  {
    return this.ClaimSearchData;
  }
  setClaimSearchData(value)
  {
    this.ClaimSearchData=value;
  }
  clearAdditionalInfo()
  {
    this.setMemberTabularData(null);
    this.setMemberInfoData(null);
    this.setProviderTabularData(null);
    this.setProviderInfoData(null);
    this.setClaimTabularData(null);
    this.setClaimInfoData(null);
    this.setMemberSearchData(null);
    this.setProviderSearchData(null);
    this.setClaimSearchData(null);
  }
}
